import React from 'react'
import cn from 'classnames'

import News from './News'
import Text from './Text'
import Bio from './Bio'
import styles from './Team.module.css'

export default () => (
  <div className={styles.container}>
    <div className={cn(styles.news, 'reveal')}>
      <div className={styles.newsContainer}>
        <News to="https://m.me/madebybowtie" style="badge" title="Hiring!">
          <span>We're looking for <b>Android</b> & <b>iOS Developers</b></span>
        </News>
        <News to="https://m.me/madebybowtie" style="inline">
          <span>We're looking for a pixel loving <b>Digital Designer</b></span>
        </News>
      </div>
    </div>

    <div className={styles.content}>

      <h4 className="reveal">Our Team</h4>

      <div className={styles.team}>
        <Bio
          name="Simon"
          role="iOS DEVELOPER"
          image={require('../images/crew-simon@2x.jpg')}
          twitter="blommegard"
          github="blommegard"
        />
        <Bio
          name="Marcus"
          role="CREATIVE"
          image={require('../images/crew-marcus@2x.jpg')}
          twitter="gellermark"
          github="gellermark"
          instagram="gellermark"
          dribbble="gellermark"
        />
        <Bio
          name="Edward"
          image={require('../images/crew-edward@2x.jpg')}
          role="iOS & BACKEND DEVELOPER"
          twitter="edwardjewson"
          github="edwardjewson"
        />
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Team.js